import type { HelpFile } from '../../types/help'
import { CreateTargetSystemTestIds } from '../../../testids/CreateTargetSystemTestIds'

export const createTargetSystemHelp: HelpFile = {
  docPage: '/docs/systems/overview',
  texts: {
    [CreateTargetSystemTestIds.cardTitleCreateSystem]:
      'Neues Zielsystem vom festgelegten Typ anlegen. Pflichtattribute leiten sich aus den Attributdefinitionen des Typs ab.',
    [CreateTargetSystemTestIds.btnCancelCreateSystem]: null,
    [CreateTargetSystemTestIds.btnSubmitCreateSystem]: null,
    [CreateTargetSystemTestIds.inputSystemName]: null,
    [CreateTargetSystemTestIds.selectEnvironment]: null,
  },
}
